import { render, staticRenderFns } from "./ToolTargetPreferredObjectStorePopover.vue?vue&type=template&id=2e0610ef&"
import script from "./ToolTargetPreferredObjectStorePopover.vue?vue&type=script&lang=js&"
export * from "./ToolTargetPreferredObjectStorePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports